<template>
	<div class="full">
		<div class="full" v-if="level==1"><img src="../img/game_bg1.jpg" /></div>
		<div class="full" v-if="level==2"><img src="../img/game_bg2.jpg" /></div>
		<div class="full" v-if="level==3"><img src="../img/game_bg3.jpg" /></div>
		<div class="game_title1" v-if="level==1"><img src="../img/game_title1.png" /></div>
		<div class="game_title2" v-if="level==2"><img src="../img/game_title2.png" /></div>
		<div class="game_title3" v-if="level==3"><img src="../img/game_title3.png" /></div>
		<div class="full" ref="stage"></div>
		<div class="system_button1" v-hammer:tap="bgm"><img src="../img/system_button1.png" /></div>
		<div class="system_button2" v-hammer:tap="rule"><img src="../img/system_button2.png" /></div>
		<div class="game_ele1">
			<img src="../img/game_ele1.png" />
			<div class="game_time">
				<span>{{(time/100).toFixed(2)}}</span>
				<div
					style="position: absolute;font-size: 18px;margin-left: 6px;font-weight: bold;bottom: 15%;right: 0;">
					秒</div>
			</div>

		</div>
		<div class="game_ele2">
			<img src="../img/game_ele2.png" />
			<div class="game_pro">
				<!-- <div class="full" :style="{left:(-proleft-100)+'%'}"><img src="../img/game_pro.png" /></div> -->
				<div class="full" :style="{left:proleft+'%'}"><img src="../img/game_pro.png" /></div>
			</div>
		</div>
		<div class="game_ele3"><img src="../img/game_ele3.png" /></div>

		<div class="game_milk1" v-if="level==1"><img src="../img/game_milk1.png" /></div>
		<div class="game_milk2" v-if="level==2"><img src="../img/game_milk2.png" /></div>
		<div class="game_milk3" v-if="level==3"><img src="../img/game_milk3.png" /></div>

		<div class="game_button1" :data-type="1" v-hammer:tap="alertShow">
			<img src="../img/game_button1.png" />
			<div class="times flex">{{tool.time}}</div>
		</div>
		<div class="game_button2" :data-type="2" v-hammer:tap="alertShow">
			<img src="../img/game_button2.png" />
			<div class="times flex">{{tool.order}}</div>
		</div>
		<div class="game_button3" :data-type="3" v-hammer:tap="alertShow">
			<img src="../img/game_button3.png" />
			<div class="times flex">{{tool.notice}}</div>
		</div>
		<transition name="fade">
			<game-alert v-if="toolType!=0" :level="level" :type="toolType" @back="alertBack" />
		</transition>

		<transition name="fade">
			<div class="full zhe" :style="{zIndex:aminiateBuff?99:-99}" v-if="status=='success' && level==1">
				<div class="animate_container">
					<animate1 @next="next" :status="status" />
				</div>
			</div>
		</transition>
		<transition name="fade">
			<div class="full zhe" :style="{zIndex:aminiateBuff?99:-99}" v-if="status=='success' && level==2">
				<div class="animate_container">
					<animate2 @next="next" :status="status" />
				</div>
			</div>
		</transition>
		<transition name="fade">
			<div class="full zhe" :style="{zIndex:aminiateBuff?99:-99}" v-if="status=='success' && level==3">
				<div class="animate_container">
					<animate3 @next="next" :status="status" />
				</div>
			</div>
		</transition>
		
		<transition name="fade">
			<rule v-if="ruleShow" @ruleBack="ruleBack"  />
		</transition>
		<transition name="fade">
			<div class="full zhe" v-if="noticeShow" v-hammer:tap="noticeHide">
				<div class="notice_ele1"><img src="../img/notice_ele1.png" /></div>
				<div class="notice_ele2"><img src="../img/notice_ele2.png" /></div>
				<div class="notice_ele3"><img src="../img/notice_ele2.png" /></div>
				<div class="notice_ele4"><img src="../img/notice_ele2.png" /></div>
			</div>
		</transition>
		
		<transition name="fade">
			<abpage v-if="failShow">
				<div class="full fail_container zhe flex" v-if="!shareShow">
					<div class="game_fail"><img src="../img/game_fail.png" /></div>
					<div class="game_fail_button" v-hammer:tap="share"><img src="../img/game_fail_button.png" /></div>
				</div>
				<div class="zhe full" v-if="shareShow" v-hammer:tap="flash">
					<div class="share_ele1"><img src="../img/share_ele2.png" /></div>
				</div>
			</abpage>
		</transition>		
		
		<div class="ready_container full zhe" v-if="readyShow">
			<div class="ready_ele1" v-hammer:tap="gameBegin"><img src="../img/ready_ele1.png" /></div>
		</div>		
		
	</div>
</template>

<style scoped>
	.ready_ele1{
		position: absolute;
		width: 40%;
		left: 30.3%;
		top: 26.7%;
	}
	.fail_container{
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.game_fail{
		position: relative;
		width: 76.5%;
		
	}
	.game_fail_button{
		position: relative;
		width: 51.1%;
		margin-top: 20px;
		
	}
	.notice_ele1{
		position: absolute;
		width: 45.1%;
		left: 37.9%;
		top: 24.5%;
		-webkit-animation: notice_ele1 1s linear alternate infinite;
	}
	@-webkit-keyframes notice_ele1 {
		0% {
			-webkit-transform: translate(0,0);
		}
	
		100% {
			-webkit-transform: translate(10px,0);
		}
	
	}	
	.notice_ele2{
		position: absolute;
		width: 18.4%;
		left: 13.1%;
		top: 27.6%;		
	}
	.notice_ele3{
		position: absolute;
		width: 18.4%;
		left: 31.3%;
		top: 36.4%;		
	}
	.notice_ele4{
		position: absolute;
		width: 18.4%;
		left: 49.7%;
		top: 45.2%;		
	}
	.animate_container {
		position: absolute;
		width: 86.1%;
		height: 65.3%;
		left: 6.8%;
		top: 15.3%;
	}

	.system_button1 {
		position: absolute;
		width: 10.4%;
		left: 84.1%;
		top: 12.2%;
	}

	.system_button2 {
		position: absolute;
		width: 10.4%;
		left: 84.1%;
		top: 17.5%;
	}

	.game_title1 {
		position: absolute;
		width: 58.1%;
		left: 15.6%;
		top: 12.4%;
	}

	.game_title2 {
		position: absolute;
		width: 72.9%;
		left: 8.9%;
		top: 12.4%;
	}

	.game_title3 {
		position: absolute;
		width: 63.5%;
		left: 12.9%;
		top: 12.4%;
	}

	.game_ele1 {
		position: absolute;
		width: 43.2%;
		left: 29.2%;
		top: 66.1%;
	}

	.game_ele2 {
		position: absolute;
		width: 64.9%;
		left: 18.4%;
		top: 77%;
	}

	.game_ele3 {
		position: absolute;
		width: 18%;
		left: 5.9%;
		top: 74.6%;
	}

	.game_milk1 {
		position: absolute;
		width: 11.5%;
		left: 79.5%;
		top: 74%;
	}

	.game_milk2 {
		position: absolute;
		width: 11.9%;
		left: 79.2%;
		top: 74.2%;
	}

	.game_milk3 {
		position: absolute;
		width: 12%;
		left: 79.1%;
		top: 74%;
	}

	.game_button1 {
		position: absolute;
		width: 26.8%;
		left: 7.7%;
		top: 82.5%;
	}

	.game_button2 {
		position: absolute;
		width: 26.8%;
		left: 37.5%;
		top: 82.5%;
	}

	.game_button3 {
		position: absolute;
		width: 26.8%;
		left: 67.2%;
		top: 82.5%;
	}

	.game_pro {
		position: absolute;
		width: 90.8%;
		height: 42.5%;
		left: 3.9%;
		top: 18.8%;
		border-radius: 1000px;
		overflow: hidden;
	}

	.game_time {
		position: absolute;
		width: 60%;
		left: 17.6%;
		top: 18%;
		color: #8dd144;
		font-family: 'time';
		font-size: 42px;
	}

	.times {
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: absolute;
		background-color: red;
		color: white;
		font-size: 12px;
		width: 16px;
		height: 16px;
		border-radius: 100px;
		top: -4px;
		right: 8px;

	}
</style>
<script>
	import * as PIXI from 'pixi.js'
	import Block from '../lib/block.js'
	import gameAlert from './game_alert.vue'
	import animate1 from './animate1.vue'
	import animate2 from './animate2.vue'
	import animate3 from './animate3.vue'
	export default {
		props: {
			level: {
				type: Number,
				default: function() {
					return 0
				}
			}
		},
		data() {
			return {
				//level: 3,
				toolType: 0,
				gamestop: true,
				gametime: 1965,
				timehandle: 0,
				time: 0,
				blockIndex: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
				blockSeed: [],
				blockSelect: [],
				blockArr: [],
				blockArrIndex: [],
				proleft: -0,
				status: '',
				aminiateBuff:false,
				ruleShow:false,
				failShow:false,
				shareShow : false,
				readyShow:false
			};
		},
		computed: {
			noticeShow(){
				return this.$store.state.noticeShow
			},
			tool() {
				return this.$store.state.tool
			}
		},
		mounted() {
			this.$store.commit('pauseYinxiao',{name:'success'})
			setTimeout(()=>{
				this.aminiateBuff = true
			},1000)
			this.gameInit()
			// setTimeout(()=>{
			// 	this.status='success'
			// },2000)
		},
		watch: {

		},
		methods: {
			gameInit() {
				this.time = this.gametime
				this.app = new PIXI.Application({
					width: 750,
					height: 1564,
					backgroundAlpha: 0,
					resolution: 1,
				})
				this.app.view.classList.add('full')
				this.$refs.stage.appendChild(this.app.view)
				let container = new PIXI.Container()
				this.app.stage.addChild(container)
				if (this.level == 1) {
					this.selectBlock(5)
					for (let i = 0; i < 12; i++) {
						let block = new Block(this.blockSeed[i], {
							width: 138,
							height: 149,
							x: 138 * (i % 4) + 97,
							y: 138 * Math.floor(i / 4) + 432,
						}, i)
						block.on('pointerup', () => {
							this.select(block)
						})
						this.blockArr.push(block)
						this.blockArrIndex.push(block.index)
						container.addChild(block)
					}
					for (let i = 0; i < 3; i++) {
						let block = new Block(this.blockSeed[12 + i], {
							width: 138,
							height: 149,
							x: 138 * (i % 4) + 167,
							y: 138 * Math.floor(i / 4) + 845,
						}, 12 + i)
						block.on('pointerup', () => {
							this.select(block)
						})
						this.blockArr.push(block)
						this.blockArrIndex.push(block.index)
						container.addChild(block)
					}
				}
				if (this.level == 2) {
					this.selectBlock(12)
					for (let i = 0; i < this.blockSeed.length; i++) {
						let block = new Block(this.blockSeed[i], {
							width: 100,
							height: 108,
							x: 100 * (i % 6) + 76,
							y: 100 * Math.floor(i / 6) + 420,
						}, i)
						block.on('pointerup', () => {
							this.select(block)
						})
						this.blockArr.push(block)
						this.blockArrIndex.push(block.index)
						container.addChild(block)
					}
				}
				if (this.level == 3) {
					this.selectBlock(24)
					console.log(this.blockSeed)
					for (let i = 0; i < this.blockSeed.length; i++) {
						let block = new Block(this.blockSeed[i], {
							width: 76,
							height: 82,
							x: 76 * (i % 9) + 32,
							y: 76 * Math.floor(i / 9) + 413,
						}, i)
						block.on('pointerup', () => {
							this.select(block)
						})
						this.blockArr.push(block)
						this.blockArrIndex.push(block.index)
						container.addChild(block)
					}
				}
				if(!this.noticeShow){
					this.readyShow = true
					// this.$dialog.alert({
					// 	title: '提示',
					// 	message: '准备开始',
					// }).then(() => {
					// 	this.gameBegin()
					// })					
				}



			},
			noticeHide(){
				this.$store.commit('setNoticeShow', {
					value: false
				})	
				setTimeout(()=>{
					this.gameBegin()
				},500)
			},
			gameBegin() {
				this.readyShow = false
				this.$store.commit('setTool', {
					time: 1,
					order: 1,
					notice: 1
				})
				this.gamestop = false
				this.timehandle = setInterval(() => {
					if (this.time <= 0) {
						this.gamestop = true
						clearInterval(this.timehandle)
						this.fail()
					} else {
						if (!this.gamestop) {
							this.time--
							this.proleft = -(this.gametime - this.time) / this.gametime * 100
						}
					}
				}, 10)
			},
			selectBlock(total) {
				let seed = []
				if (total <= this.blockIndex.length) {
					seed = this.getRandom({
						'arry': this.blockIndex,
						'range': total
					})
				} else {
					let arr = []
					for (let i = 0; i < total - this.blockIndex.length; i++) {
						let rand = this.blockIndex[Math.floor(Math.random() * 12)]
						arr.push(rand)
					}
					this.blockIndex = this.blockIndex.concat(arr)
					seed = this.getRandom({
						'arry': this.blockIndex,
						'range': total
					})
					console.log(this.blockIndex)
				}
				let blockSeed = []
				for (let i = 0; i < seed.length; i++) {
					blockSeed.push(seed[i])
					blockSeed.push(seed[i])
					blockSeed.push(seed[i])
				}

				this.blockSeed = this.$tool.shuffle(blockSeed)
				
			},
			getRandom(opt) {
				let old_arry = opt.arry
				let range = opt.range
				range = range > old_arry.length ? old_arry.length : range
				let newArray = [].concat(old_arry)
				let valArray = []
				for (let n = 0; n < range; n++) {
					let r = Math.floor(Math.random() * (newArray.length))
					valArray.push(newArray[r])
					newArray.splice(r, 1)
				}
				return valArray
			},
			select(e) {
				if (this.blockSelect.length < 3 && !this.gamestop) {
					e.active()
					this.blockSelect.push(e)
					if (this.blockSelect.length >= 3) {
						this.check()
					}
					this.$store.commit('playYinxiao',{name:'tap'})
				}
			},
			check() {
				let num = 0
				let block = 0
				let buff = true
				this.blockSelect.forEach((item) => {
					if (block == 0) {
						block = item.block
						num++
					} else {
						if (block == item.block) {
							buff = true
							num++
						} else {
							buff = false
							num = 1
						}
					}
				})
				if (buff && num == 3) {
					do {
						this.blockSelect.pop().display()
					} while (this.blockSelect.length > 0)
					this.$store.commit('playYinxiao',{name:'combo'})
					this.isfinish()
				} else {
					setTimeout(() => {
						do {
							this.blockSelect.pop().normal()
						} while (this.blockSelect.length > 0)
					}, 200)
				}
				this.hideNotice()

			},
			isfinish() {
				let display = 0
				this.blockArr.forEach((item) => {
					if (item.isdisplay) {
						display++
					}
				})
				if (display >= this.blockArr.length) {
					this.success()
					this.$store.commit('playYinxiao',{name:'success'})
				}
			},
			success() {
				clearInterval(this.timehandle)
				this.status = 'success'
				if(this.level>=3){
					this.$api.gameSuccess()
				}
				//this.$toast('success')
				// setTimeout(() => {
				// 	if (this.level < 3) {
				// 		this.$store.commit('setCurrentPage', {
				// 			page: 'game' + (this.level + 1)
				// 		})
				// 	}
				// }, 1000)
			},
			fail() {
				this.status = 'fail'
				//this.$toast('fail')
				this.failShow = true
			},
			next() {
				setTimeout(() => {
					if (this.level < 3) {
						this.$store.commit('setCurrentPage', {
							page: 'game' + (this.level + 1)
						})
					} else {
						this.$store.commit('setBgmIndex',{value:1})
						this.$store.commit('setCurrentPage', {
							page: 'p2'
						})
					}
				}, 1000)
				
				
			},
			reflashBlockOrder() {

				let normalBlockIndex = []
				this.blockArr.forEach((item) => {
					if (!item.isdisplay) {
						normalBlockIndex.push(item.index)
					}
				})
				let newNormalBlockIndex = this.$tool.shuffle(normalBlockIndex)
				this.blockArr.forEach((item, index) => {
					if (!item.isdisplay) {
						if (newNormalBlockIndex.length > 0) {
							this.blockArrIndex[index] = newNormalBlockIndex.pop()
						}
					}
				})
				this.blockArrIndex.forEach((item, index) => {
					for (let i = 0; i < this.blockArr.length; i++) {
						if (this.blockArr[i].index == item) {
							this.blockArr[index].initChange(this.blockArr[i])
							break
						}
					}
				})
				for (let i = 0; i < this.blockArr.length; i++) {
					this.blockArr[i].setChange()
				}
				this.$store.commit('playYinxiao',{name:'flash'})
			},
			addTime() {
				this.time = Math.min(1965, this.time + 900)
				this.$store.commit('playYinxiao',{name:'addtime'})
			},
			showNotice() {
				this.blockSelect = []
				let num = 0
				let block = 0
				this.blockArr.forEach((item) => {
					if(!item.isdisplay){
						item.normal()
						if (num < 3) {
							if (block == 0) {
								block = item.block
								item.noticeShow()
								num++
							} else {
								if (item.block == block) {
									item.noticeShow()
									num++
								}
							}
						
						}
					}
					
				})
				this.$store.commit('playYinxiao',{name:'notice'})
			},
			hideNotice() {
				this.blockArr.forEach((item) => {
					item.noticeHide()
				})
			},
			alertShow(e) {
				let type = parseInt(e.target.dataset.type)
				if (!this.gamestop) {
					if (type == 1 && this.tool.time > 0 || type == 2 && this.tool.order > 0 || type == 3 && this.tool
						.notice >
						0) {
						this.gamestop = true
						this.toolType = type
					}
				}
			},
			alertBack(e) {
				this.toolType = 0
				if (e.type == 1) {
					this.$store.commit('setTool', {
						time: -1,
					})
					this.addTime()
				}
				if (e.type == 2) {
					this.$store.commit('setTool', {
						order: -1,
					})
					this.reflashBlockOrder()
				}
				if (e.type == 3) {
					this.$store.commit('setTool', {
						notice: -1,
					})
					this.showNotice()
				}
				this.gamestop = false
			},
			bgm(){
				this.$emit('bgm')
			},
			rule(){
				this.gamestop = true
				this.ruleShow = true
			},
			ruleBack(){
				this.gamestop = false
				this.ruleShow = false
			},
			share(){
				this.$emit('flash')
				// this.shareShow = true
				// window._hmt.push(['_trackEvent', "share", "click"])
			},
			flash(){
				this.$emit('flash')
			}

		},
		components: {
			gameAlert,
			animate1,
			animate2,
			animate3
		}
	}
</script>
